import { NAV, CONFIG } from "@/lib/data";
import { Logo } from "@/components/Logo";
import { ArrowUpRight } from "lucide-react";

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/sanvalio/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/deepankshi-saxena/" },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61593807128453" },
  { label: "Sanvalio.in", href: "https://www.sanvalio.in" },
  { label: "Academy", href: "https://www.sanvalioacademy.com" },
];

export const Footer = ({ onBook }) => (
  <footer className="relative border-t border-[var(--border-subtle)] overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10 pt-24 lg:pt-32 pb-8">
      <p className="font-heading text-sm font-semibold uppercase tracking-[0.22em] text-[var(--accent-primary)] mb-7">
        Let's talk
      </p>
      <h2 className="font-display text-5xl sm:text-7xl lg:text-8xl font-extrabold leading-[0.92] max-w-4xl">
        Let's build something <span className="text-gradient">iconic.</span>
      </h2>

      <div className="mt-10 flex flex-wrap gap-4">
        <button onClick={onBook} data-testid="footer-book-btn" className="btn-accent rounded-full px-8 py-4 font-heading font-semibold">
          Book a Call
        </button>
        <a href={`mailto:${CONFIG.email}`} className="group inline-flex items-center gap-2 rounded-full border border-[var(--border-subtle)] px-8 py-4 font-heading font-medium hover:border-[var(--border-hover)] transition-colors">
          {CONFIG.email}
          <ArrowUpRight size={18} className="text-[var(--text-muted)] group-hover:text-[var(--accent-primary)] transition-colors" />
        </a>
      </div>

      <div className="mt-20 grid gap-8 md:grid-cols-[1fr_auto] md:items-center border-t border-[var(--border-subtle)] pt-8">
        <div className="flex flex-wrap items-center gap-x-8 gap-y-4">
          <Logo className="h-7" />
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {NAV.map((n) => (
              <a key={n.href} href={n.href} className="link-underline font-heading text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">{n.label}</a>
            ))}
          </nav>
        </div>
        <div className="flex flex-wrap items-center gap-6">
          {SOCIALS.map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`social-link-${s.label.toLowerCase()}`} className="link-underline font-heading text-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">{s.label}</a>
          ))}
        </div>
      </div>

      <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="font-mono text-xs text-[var(--text-muted)]">© {new Date().getFullYear()} Sanvalio Studio — AI-powered creative agency.</p>
        <div className="flex gap-6 font-mono text-xs text-[var(--text-muted)]">
          <a href="#" className="hover:text-[var(--text-primary)]">Privacy</a>
          <a href="#" className="hover:text-[var(--text-primary)]">Terms</a>
        </div>
      </div>

      <div className="pointer-events-none select-none mt-8 -mb-8 text-center font-display font-extrabold leading-none text-[var(--text-primary)] opacity-[0.04] text-[24vw]">
        Sanvalio
      </div>
    </div>
  </footer>
);
